module.exports = __webpack_public_path__ + "img/toolbar_sfxx.e6605acb.png";